import { render, staticRenderFns } from "./mail_config.vue?vue&type=template&id=152bd183&scoped=true&"
import script from "./mail_config.vue?vue&type=script&lang=ts&"
export * from "./mail_config.vue?vue&type=script&lang=ts&"
import style0 from "./mail_config.vue?vue&type=style&index=0&id=152bd183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bd183",
  null
  
)

export default component.exports